module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_126-0579422cfeec53c8e5808a7883f95399.png";